import Vue, { Ref } from 'vue';
import { ImagesSliderPhoto, ImagesSliderVideo } from '@ve/components/images-slider/common/types';
import FullscreenSlider from '@ve/components/fullscreenImagesSlider/desktop/FullscreenSlider.vue';
import { Store } from 'vuex';
import { BaseState } from '@ve/router/types';
import { NAMESPACE as HOTEL_PAGE_GALLERY_STORE } from '@ve/pages/hotel/store/HotelPageGalleryStore';
import HotelTrackingService from '@ve/pages/hotel/analytics/yandexAnalytics/hotelTrackingService';

export default ({
                    el, images, videos, video, isVisibleThumbs = true, parentSelectedIndex, isFullScreenSlider, store,
                }: {
    el: string;
    images: ImagesSliderPhoto[];
    videos: ImagesSliderVideo[];
    video: ImagesSliderVideo,
    isVisibleThumbs: boolean,
    parentSelectedIndex: Ref<number>,
    isFullScreenSlider: Ref<boolean>,
    store: Store<BaseState>,
}) => {
    const hotelTrackingService = new HotelTrackingService();
    return new Vue({
        name: 'images-slider-hotel-fullscreen',
        render: (h) => h(FullscreenSlider, {
            props: {
                images,
                videos,
                video,
                isVisibleThumbs,
                isFullScreenSlider,
                parentSelectedIndex,
            },
            on: {
                'fullscreen-slider-click': () => {
                    const paramsForHotelPageGalleryAnalytic = store.getters[`${HOTEL_PAGE_GALLERY_STORE}/paramsForHotelPageGalleryAnalytic`];
                    hotelTrackingService.hotelPageGalleryClick(paramsForHotelPageGalleryAnalytic);
                },
            },
        }),
        store,
    }).$mount(el);
};